import React, { useContext, useEffect, useRef, useState } from 'react';
import { LaterScreen } from './Later';
import { EmergentScreen } from './Emergent';
import { ExemplarCombined, LaterExemplar, EmergentExemplar } from '../../types';
import { StyledScreenWrapper } from '../Styled';
import { StyledInsideWrapper } from '../Styled/StyledWrappers';
import { EMERGENT } from '../../constants';
import { DEFAULT_EXEMPLAR_HEIGHT, DEFAULT_EXEMPLAR_WIDTH } from '../../constants/exemplar';
import { IntroductionToHybridModal } from '../Modal/IntroductionToHybridModal';
import { ExemplarContext as LaterExemplarContext } from '../../contexts/laterContext';
import { ExemplarContext as EmergentExemplarContext } from '../../contexts/emergentContext';
import { SAVED_EXEMPLAR } from '../../constants/navigation';
import { isEmpty } from 'lodash';

export interface IScreen {
  exemplar: ExemplarCombined;
  exemplarId: number;
  mode: string;
  type: string;
  stage: string;
  isFullScreen: boolean;
}

export default interface IScreens {
  readonly early: React.FC;
  readonly emergent: React.FC;
  readonly developing: React.FC;
}

export const ExemplarScreen: React.FC<IScreen> = (props): JSX.Element => {
  const { exemplar, exemplarId, stage, type, isFullScreen } = props;
  const exemplarWrapperRef = useRef<HTMLDivElement>(null);
  const exemplarWrapper = exemplarWrapperRef.current;

  const [exemplarWrapperDimensions, setExemplarWrapperDimensions] = useState({
    width: DEFAULT_EXEMPLAR_WIDTH,
    height: DEFAULT_EXEMPLAR_HEIGHT,
  });

  const {
    isIntroducedToHybrid,
    setIntroductionToHybrid,
    exemplarState: laterExemplarState,
    setExemplar: setLaterExemplar,
  } = useContext(LaterExemplarContext);

  const { exemplarState: emergentExemplarState, setExemplar: setEmergentExemplar } =
    useContext(EmergentExemplarContext);

  useEffect(() => {
    stage === EMERGENT
      ? setEmergentExemplar(exemplar as EmergentExemplar)
      : setLaterExemplar(exemplar as LaterExemplar);
  }, []);

  useEffect(() => {
    setExemplarWrapperDimensions({
      width: exemplarWrapper?.offsetWidth || DEFAULT_EXEMPLAR_WIDTH,
      height: exemplarWrapper?.offsetHeight || DEFAULT_EXEMPLAR_HEIGHT,
    });
  }, [exemplarWrapper?.offsetWidth, exemplarWrapper?.offsetHeight]);

  const renderExemplar = (stage: keyof IScreens) => {
    if (stage === EMERGENT) {
      return (
        !isEmpty(emergentExemplarState) && (
          <EmergentScreen {...props} exemplarId={exemplarId} dimensions={exemplarWrapperDimensions} />
        )
      );
    }

    return (
      !isEmpty(laterExemplarState) && (
        <LaterScreen {...props} exemplarId={exemplarId} dimensions={exemplarWrapperDimensions} />
      )
    );
  };

  return (
    <StyledInsideWrapper isFullScreen={isFullScreen}>
      <IntroductionToHybridModal
        showModal={type != SAVED_EXEMPLAR && (isIntroducedToHybrid as boolean)}
        setShowModal={setIntroductionToHybrid}
      />
      <StyledScreenWrapper data-testid="screen-wrapper" ref={exemplarWrapperRef} stage={stage}>
        {renderExemplar(stage as keyof IScreens)}
      </StyledScreenWrapper>
    </StyledInsideWrapper>
  );
};
